// mirrors api/appdata/system.py — keep both in sync when a system id changes
export const DEFAULT_KAER_TEAM_ID = "00000002-0000-0000-0000-000000000000";
export const SYSTEM_SUBJECT_ID = "11111111-1111-1111-1111-111111111113";
export const KAER_COMPANY_ID = "11111111-1111-1111-1111-333333333333";
export const KAER_COMPANY_SUBJECT_ID = "11111111-1111-1111-1111-444444444444";

export const SUPER_ADMIN_EMAIL = "admin@kaer.de";

export const isSuperAdminUser = (email: string | undefined | null) =>
  email === SUPER_ADMIN_EMAIL;
